var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let { property, resId, isMobile, new_plan } = options;

__p+='\n  <div class="component_property-card component_map-mini-card mobile-'+
((__t=( isMobile ))==null?'':__t)+
'" data-ldpurl="'+
((__t=( property.ldpUrl ))==null?'':__t)+
'" data-agentid="'+
((__t=( property.agent_id ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'" data-omtag="'+
((__t=( property.omTag ))==null?'':__t)+
'" data-status="'+
((__t=( property.dataStatus ))==null?'':__t)+
'">\n    <div class="card-box">\n      <a href="'+
((__t=( property.ldpUrl ))==null?'':__t)+
'" class="display-block">\n          <div class="photo-wrap" data-label="property-photo">\n            ';
 if(property.photo){ 
__p+='\n            <img src="'+
((__t=( MOVE.MapMiniCard.getMiniCardPhoto(property.photo) ))==null?'':__t)+
'" alt="'+
((__t=( property.address ))==null?'':__t)+
'" title="'+
((__t=( property.address ))==null?'':__t)+
'">\n          ';
 } else { 
__p+='\n           <div class="coming-soon-img %>"></div>\n          ';
 } 
__p+='\n        </div>\n      </a>\n      <div class="minicard-price">\n\n      ';
 if(property.search_flags && (property.search_flags.is_new_listing || property.search_flags.is_pending || property.search_flags.is_contingent || property.open_house_display)) { 
__p+='\n          <div class="minicard-status">\n            ';
 if(property.search_flags.is_new_listing) { 
__p+='\n              <span class="label label-green" data-label="property-label-new">New</span>\n            ';
 } 
__p+='\n            ';
 if(property.search_flags.is_pending) { 
__p+='\n              <span class="label label-red" data-label="property-label-pending">Pending</span>\n            ';
 } 
__p+='\n            ';
 if(property.search_flags.is_contingent) { 
__p+='\n              <span class="label label-red" data-label="property-label-contingent">Contingent</span>\n            ';
 } 
__p+='\n            ';
 if(property.open_house_display) { 
__p+='\n              <span class="label label-dark-transparent label-outline-none"> Open House '+
((__t=( property.open_house_display ))==null?'':__t)+
'</span>\n            ';
 } 
__p+='\n          </div>\n        ';
 } 
__p+='\n\n        ';
 if (property.priceDisplay === "") { 
__p+='\n        <span class="font-semibold" data-label="mini-card-price">No Estimate Available</span>\n        ';
 } else{ 
__p+='\n        <span class="mini-card-price ellipsis '+
((__t=( MOVE.MapMiniCard.getMiniCardPriceClass(property.status)))==null?'':__t)+
'" data-label="mini-card-price">'+
((__t=( property.priceDisplay ))==null?'':__t)+
'<span class="mini-card-price-helper '+
((__t=( MOVE.MapMiniCard.getMiniCardPriceTagClass(property.status)))==null?'':__t)+
'">/month</span></span>\n        ';
 } 
__p+='\n      </div>\n      <ul class="minicard-meta ellipsis">\n        ';
 if (property.propertyType === "land") { 
__p+='\n          <li data-label="property-meta-land">Land</li>\n        ';
 } else { 
__p+='\n          ';
 if (property.bed_display || property.bed){ 
__p+='\n            <li data-label="property-meta-beds"><span class="data-value">'+
((__t=( property.bed_display || property.bed ))==null?'':__t)+
'</span> bd</li>\n          ';
 } 
__p+='\n          ';
 if (property.bath_display || property.bath) { 
__p+='\n            <li data-label="property-meta-baths"><span class="data-value">'+
((__t=( property.bath_display || property.bath ))==null?'':__t)+
'</span> ba</li>\n          ';
 } 
__p+='\n        ';
 } 
__p+='\n        ';
 if (property.sqft_display && property.sqft_display != 0 && property.sqft_display != "0" && property.sqft_display != "0 - 0") { 
__p+='\n          <li data-label="property-meta-sqft">'+
((__t=( property.sqft_display ))==null?'':__t)+
' sq ft</li>\n        ';
 } 
__p+='\n      </ul>\n\n      <div class="minicard-address">\n        '+
((__t=( property.address ))==null?'':__t)+
'\n      </div>\n      ';
 new_plan ? property.status = 'ready_to_build' : property.status 
__p+='\n      ';
 if (['P', 'M'].indexOf(property.source_id) > -1 && property.status !== "recently_sold" && property.search_flags && (!property.search_flags.is_spec_home) ) { 
__p+='\n        <div class="save-wrap" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-status="'+
((__t=( property.status ))==null?'':__t)+
'">\n\n          ';
 if ($.cookie('REMEMBER_ME')) { 
__p+='\n            <a class="js-delete-listing btn-save-listing js-save-trigger" style="display:'+
((__t=( resId ? 'block' : 'none' ))==null?'':__t)+
'" data-res-id="'+
((__t=( resId ))==null?'':__t)+
'">\n              <span class="ra-stack icon-save-lg">\n                <i class="ra ra-heart icon-save ra-stack-2x js-no-listing-click"></i>\n                <i class="ra ra-heart-o ra-stack-1x js-no-listing-click"></i>\n              </span>\n            </a>\n            <a class="js-save-listing btn-save-listing js-save-trigger" style="display:'+
((__t=( resId ? 'none' : 'block' ))==null?'':__t)+
'" data-omtag="'+
((__t=( `${property.status}:srp:card:listing_save` ))==null?'':__t)+
'">\n              <span class="ra-stack icon-save-lg">\n                <i class="ra ra-heart ra-stack-1x js-no-listing-click" data-omtag="'+
((__t=( `${property.status}:srp:card:listing_save` ))==null?'':__t)+
'"></i>\n                <i class="ra ra-heart-o ra-stack-2x js-no-listing-click" data-omtag="'+
((__t=( `${property.status}:srp:card:listing_save` ))==null?'':__t)+
'"></i>\n              </span>\n            </a>\n          ';
 } else { 
__p+='\n            <a href="" class="btn-save-listing srp-save-not-logged-in js-save-trigger">\n              <span class="ra-stack icon-save-lg">\n                <i class="ra ra-heart ra-stack-1x js-no-listing-click" data-omtag="'+
((__t=( `${property.status}:srp:card:listing_save` ))==null?'':__t)+
'"></i>\n                <i class="ra ra-heart-o ra-stack-2x js-no-listing-click" data-omtag="'+
((__t=( `${property.status}:srp:card:listing_save` ))==null?'':__t)+
'"></i>\n              </span>\n            </a>\n          ';
 } 
__p+='\n        </div>\n      ';
 } 
__p+='\n    </div>\n  </div>\n';
return __p;
};



// WEBPACK FOOTER //
// ./srp/basecamp/templates/map_mini_card.jst.ejs